export const legal_de_Translation = {
  terms_and_conditions: {
    title: "Allgemeine Geschäftsbedingungen",
    intro:
      "Diese Endbenutzer-Lizenzvereinbarung ist eine gültige Vereinbarung zwischen Ihnen und der Firma. Bitte lesen Sie diese EULA sorgfältig durch. Die Regeln der EULA sind für Sie verbindlich. Wenn Sie sich nicht an die Regeln der EULA halten möchten, verwenden Sie bitte die WebApp nicht. Wenn Sie die WebApp weiterhin nutzen, bedeutet dies, dass Sie die EULA gelesen und verstanden haben und sich daran halten.",
    definitions: {
      title: "1. DEFINITIONEN UND BEGRIFFE",
      description:
        "Um die Regeln der EULA klar zu verstehen, sollten Sie sich mit der Bedeutung der im EULA verwendeten Begriffe vertraut machen. In diesem EULA haben die folgenden Begriffe, wenn sie großgeschrieben sind, die folgenden Bedeutungen:",
      definitions_list: {
        account:
          "„Konto“ – bezeichnet ein persönliches Konto eines Nutzers der Plattformdienste, das vom Plattformadministrator gemäß den Nutzungsbedingungen der Plattform oder einem ähnlichen Dokument bereitgestellt wird. Das Konto wird mit einer Plattform-ID (Kontoname) und einem Passwort aufgerufen.",
        company:
          "„Firma“, „Wir“ – bezeichnet WEBFY, ein Unternehmen mit Sitz in Irland unter folgender Adresse: Black Church. St Mary’s Place. Dublin D07 P4AX. Irland.",
        content:
          "„Inhalt“ – bezeichnet alle Arten von Inhalten, einschließlich, aber nicht beschränkt auf Daten, Texte, Bilder, Videos, Töne, Links, Software und andere Informationen in jeglicher Form, die Ihnen über die WebApp zur Verfügung gestellt werden.",
        device:
          "„Gerät“ – bezeichnet ein Smartphone, ein Tablet oder ein anderes ähnliches mobiles Gerät, das Sie entweder besitzen oder anderweitig rechtlich ausschließlich für Ihre persönliche nicht-kommerzielle Nutzung kontrollieren.",
        eula: "„EULA“ – bezeichnet diese Endbenutzer-Lizenzvereinbarung, die eine verbindliche Vereinbarung zwischen Ihnen und der Firma ist. Die EULA kann andere Dokumente wie die Datenschutzrichtlinie enthalten, die das Verhältnis zwischen Ihnen und uns bezüglich der Nutzung der WebApp regeln. Wenn ein Dokument Teil der EULA ist, wird dies klar angezeigt.",
        intellectual_property_rights:
          "„Geistige Eigentumsrechte“ – bezeichnet insgesamt Rechte aus Patenten, Marken, Urheberrechten und Geschäftsgeheimnissen sowie andere geistige Eigentums- oder Eigentumsrechte, die in jedem Land oder jeder Gerichtsbarkeit weltweit anerkannt sind, einschließlich, aber nicht beschränkt auf moralische oder ähnliche Rechte.",
        subscription:
          "„Abonnement“ – bezeichnet eine Zeitspanne, während der Sie die WebApp als Ganzes oder bestimmte zusätzliche Inhalte gegen Gebühr nutzen.",
        user_generated_content:
          "„Benutzergenerierte Inhalte“ – bezeichnet jede Form von Inhalt, einschließlich, aber nicht beschränkt auf Daten, Texte, Bilder, Videos, Töne, Links, die von Nutzern auf Online-Plattformen veröffentlicht wurden, z.B. soziale Netzwerke (z.B. Instagram, Facebook).",
        you: "„Sie“ – bezeichnet eine Einzelperson, die die WebApp nutzt.",
      },
    },
    changes_of_eula: {
      title: "2. ÄNDERUNGEN DER EULA",
      list: {
        changes_intro:
          "Wir können von Zeit zu Zeit Änderungen an dieser EULA vornehmen. Sie sollten regelmäßig die neueste Version der EULA unter dem auf der Webseite verfügbaren Link überprüfen.",
        changes_effective:
          "Wenn Sie mit den Bedingungen der aktualisierten EULA nicht einverstanden sind, dürfen Sie den WebApp ab dem Tag, an dem die aktualisierte EULA in Kraft tritt, nicht mehr nutzen. In diesem Fall dürfen Sie den WebApp nicht nutzen und müssen die Erneuerung Ihres Abonnements stornieren.",
      },
    },
    device: {
      title: "3. GERÄT",
      list: {
        use_non_owned_device:
          "Wenn Sie beabsichtigen, den WebApp auf einem Gerät zu verwenden, das Sie nicht besitzen, müssen Sie die Erlaubnis des Eigentümers haben. Sie sind verantwortlich für die Einhaltung dieser EULA, unabhängig davon, ob Sie das Gerät besitzen oder nicht.",
        access_to_non_owned_device:
          "Wenn Sie das Gerät nicht besitzen, dürfen Sie den WebApp nur über Ihr Konto nutzen.",
        responsibility:
          "Wenn Sie das Gerät gemeinsam mit anderen Personen verwenden, stellen Sie bitte sicher, dass niemand außer Ihnen den WebApp von Ihrem Konto aus nutzen kann. Alle Aktionen, die in Ihrem Konto durchgeführt werden, gelten als Ihre Aktionen, unabhängig davon, wer tatsächlich diese Aktionen ausführt. Sie sind voll verantwortlich für alle in Ihrem Konto durchgeführten Aktionen.",
        removal:
          "Wenn Sie sich entscheiden, das Gerät zu verkaufen oder anderweitig loszuwerden, müssen Sie den WebApp vom Gerät entfernen.",
      },
    },
    capacity_and_age: {
      title: "4. RECHTLICHE FÄHIGKEIT UND ALTER",
      list: {
        over_16:
          "Der WebApp ist für Benutzer über 16 Jahre vorgesehen. Wenn Sie den WebApp nutzen, bestätigen Sie, dass Sie mindestens 16 Jahre alt sind und die volle rechtliche Fähigkeit besitzen, den Vertrag abzuschließen.",
        between_16_18:
          "Wenn Sie zwischen 16 und 18 Jahre alt sind, muss Ihr Elternteil, Vormund oder ein anderer volljähriger Vertreter diese EULA in Ihrem Namen prüfen und zustimmen. Wenn Sie den WebApp nutzen, bestätigen Sie, dass Ihr Elternteil, Vormund oder ein anderer volljähriger Vertreter den Bedingungen dieser EULA zugestimmt hat und Ihnen die Nutzung des WebApp erlaubt.",
      },
    },
    intellectual_property: {
      title: "5. GEISTIGE EIGENTUMSRECHTE",
      list: {
        license_grant_and_webapp_use_terms:
          "Wir gewähren Ihnen hiermit eine nicht ausschließliche, persönliche, eingeschränkte, widerrufliche und nicht übertragbare Lizenz, um auf den WebApp zuzugreifen, ihn herunterzuladen und auf Ihrem Gerät auszuführen, vorausgesetzt, Sie stimmen allen Bedingungen dieser EULA zu. Bitte beachten Sie, dass der WebApp lizenziert und nicht verkauft wird.",
        intellectual_property_rights_and_reservation_of_rights:
          "Die Gesellschaft oder der Lizenzgeber der Gesellschaft ist der einzige Inhaber der geistigen Eigentumsrechte in Bezug auf den WebApp. Die Gesellschaft behält sich alle Rechte, Titel und Interessen am WebApp vor und behält sich alle nicht ausdrücklich in dieser EULA gewährten Rechte vor.",
        restrictions_on_transferring_rights_to_webapp:
          "Sie dürfen den WebApp nicht verkaufen, weiterverkaufen, verteilen, neu verteilen, vermieten, verleasen, unterlizenzieren, abtreten, kopieren oder auf andere Weise Rechte an den WebApp an Dritte übertragen oder gewähren.",
        restrictions_on_network_distribution_and_access:
          "Sie dürfen den WebApp nicht über ein Netzwerk verteilen oder verfügbar machen, auf dem er von mehreren Benutzern gleichzeitig heruntergeladen oder verwendet werden könnte, es sei denn, dies ist ausdrücklich von uns autorisiert.",
        prohibitions_on_interfering_with_webapp_functionality:
          "Sie dürfen keine automatischen oder manuellen Geräte oder Prozesse verwenden, um das ordnungsgemäße Funktionieren des WebApp zu beeinträchtigen. Sie dürfen jedoch jede Art von Gerät oder Prozess verwenden, um den WebApp von Ihrem Gerät zu entfernen.",
        prohibitions_on_decompiling_and_reverse_engineering:
          "Sie dürfen den WebApp oder Teile davon nicht dekompilieren, disassemblieren, rückentwickeln oder abgeleitete Werke erstellen. Alle Modifikationen oder Verbesserungen des WebApp bleiben alleiniges Eigentum der Gesellschaft.",
        prohibitions_on_unlawful_use_and_malicious_activity:
          "Sie dürfen den WebApp nicht auf eine rechtswidrige Weise, für rechtswidrige Zwecke oder auf eine Weise nutzen, die nicht mit dieser EULA übereinstimmt, noch betrügerisch oder bösartig handeln, z.B. durch Hacken oder das Einfügen von schädlichem Code wie Viren oder schädlichen Daten in den WebApp.",
      },
    },
    subscription_and_trial_period: {
      title: "6. ABONNEMENT UND TESTPHASE",
      list: {
        subscription_basis_and_fee_variation:
          "Dieser WebApp als Ganzes oder ein bestimmter Teil davon (zusätzlicher Inhalt) wird auf Abonnementbasis gegen Entgelt bereitgestellt. Die Gebühren können je nach Dauer des Abonnements variieren.",
        automatic_renewal_and_account_charge:
          "Das Abonnement verlängert sich automatisch für den gleichen Zeitraum am Ende des Abonnements zu den Kosten des gewählten Pakets. Ihr Konto wird innerhalb von 24 Stunden vor Ablauf des aktuellen Abonnements für das erneuerte Abonnement belastet.",
        cancellation_of_subscription_renewal:
          "Sie können die Verlängerung des Abonnements mindestens 24 Stunden vor Ablauf des Abonnements kündigen: In diesem Fall steht Ihnen der WebApp als Ganzes oder sein zusätzlicher Inhalt bis zum Ende des Abonnements zur Verfügung. Um die automatische Verlängerung des Abonnements zu kündigen, ändern Sie bitte die Abonnementeinstellungen Ihres Kontos. Nach Ablauf des Abonnements ist der WebApp als Ganzes oder sein zusätzlicher Inhalt nur verfügbar, wenn ein neues Abonnement erworben wird.",
        manual_cancellation_required:
          "Ihr Abonnement wird nicht automatisch beendet. Sie müssen die automatische Verlängerung Ihres Abonnements kündigen, um nicht mit den Kosten des neuen Abonnements belastet zu werden.",
        free_trial_period_and_auto_conversion:
          "Der WebApp bietet eine kostenlose 7-tägige Testphase an. Während dieses Zeitraums können Sie den WebApp oder seinen zusätzlichen Inhalt kostenlos nutzen. Bitte beachten Sie, dass am Ende der Testphase automatisch ein kostenpflichtiges Abonnement für den kürzest verfügbaren Zeitraum abgeschlossen wird und Ihr Konto mit den Kosten dieses Abonnements belastet wird, es sei denn, Sie kündigen das Abonnement über die Abonnementeinstellungen Ihres Kontos mindestens 24 Stunden vor Ende der kostenlosen Testphase.",
      },
    },
    fees_and_purchase_terms: {
      title: "7. GEBÜHREN UND KAUFSBEDINGUNGEN",
      list: {
        subscription_costs_availability:
          "Die Kosten aller Abonnements sind auf der Webseite verfügbar.",
        payment_processing_by_platform_administrator:
          "Wenn Sie ein Abonnement erwerben, belastet der Plattform-Administrator Ihr Konto und sammelt das Geld in unserem Namen. Die Zahlung wird durch ein Zahlungssystem verarbeitet, das vom Plattform-Administrator implementiert wurde.",
        no_access_to_payment_information:
          "Bitte beachten Sie, dass wir Ihre Zahlung weder verarbeiten noch Zugriff auf Ihre Zahlungsinformationen haben, wie zum Beispiel, unter anderem, Ihre Kreditkartendaten, Ihren Namen oder andere damit zusammenhängende Informationen.",
        questions_on_payment_processing:
          "Sollten Sie Fragen zum Zahlungsprozess haben, wenden Sie sich bitte an den Benutzersupport des Plattform-Administrators.",
        account_charge_timing:
          "Ihr Konto wird innerhalb von 24 Stunden vor Ende des aktuellen Abonnements mit den Kosten des neuen Abonnements belastet. Wenn Sie die automatische Verlängerung innerhalb der letzten 24 Stunden des Abonnements kündigen, tritt diese Kündigung am Ende des neuen Abonnements in Kraft.",
        no_refunds_and_immediate_content_access:
          "Bitte beachten Sie, dass wir keine Rückerstattungen vornehmen. Der digitale Inhalt wird Ihnen sofort nach der Belastung der Abonnementgebühr auf Ihrem Konto zur Verfügung gestellt.",
      },
    },
    user_generated_content: {
      title: "8. BENUTZERGEPFLANZTER INHALT",
      list: {
        exposure_to_objectionable_content:
          "Da Sie auf Beiträge anderer Instagram-Nutzer zugreifen können, können Sie möglicherweise auf potenziell anstößigen benutzergenerierten Inhalt stoßen. Bitte beachten Sie, dass das Unternehmen keinen benutzergenerierten Inhalt, der auf sozialen Netzwerken gepostet wird, kontrolliert oder vorab überprüft.",
        modifications_and_censorship:
          "Jede Art von Änderungen oder Zensur durch das Unternehmen in Bezug auf benutzergenerierten Inhalt kann als Verletzung von Menschenrechten oder Urheberrechten angesehen werden und Sie möglicherweise in die Irre führen.",
        handling_objectionable_content:
          "Wenn Sie mit anstößigem Inhalt konfrontiert werden, können Sie die Funktionen des jeweiligen sozialen Netzwerks nutzen, um anstößigen benutzergenerierten Inhalt zu verfolgen und zu löschen.",
        company_disclaimer:
          "Unter keinen Umständen haftet das Unternehmen für benutzergenerierten Inhalt.",
      },
    },
    disclaimer: {
      title: "9. HAFTUNGSAUSSCHLUSS",
      list: {
        general_disclaimer_of_warranties:
          "Soweit nach geltendem Recht zulässig, lehnen wir und unsere Tochtergesellschaften, Führungskräfte, Mitarbeiter, Vertreter, Partner und Lizenzgeber ausdrücklich alle Garantien jeglicher Art, sei es ausdrücklich oder stillschweigend, hinsichtlich der Genauigkeit, Angemessenheit oder Vollständigkeit der Informationen in unserer WebApp oder durch die Dienste erstellten Informationen ab.",
        content_provided_as_is:
          "Der Inhalt in unserer WebApp wird Ihnen auf einer „wie besehen“-Basis bereitgestellt, ohne jegliche Garantie hinsichtlich der Marktfähigkeit oder Eignung für einen bestimmten Zweck oder eine bestimmte Verwendung. Wir garantieren nicht, dass Sie ein erwartetes Ergebnis aus der Nutzung der WebApp erzielen werden.",
        no_warranty_on_specifics: {
          title: "Wir übernehmen keine Garantie dafür, dass:",
          a: "die WebApp Ihre Anforderungen erfüllt;",
          b: "die WebApp fehlerfrei, sicher oder ununterbrochen ist;",
          c: "Fehler in der Funktionalität der WebApp behoben werden;",
          d: "die Qualität der WebApp Ihren Erwartungen entspricht.",
        },
        limitation_of_liability:
          "Wir übernehmen keine Verantwortung oder Haftung für Fehler oder Auslassungen. Wir sind nicht verantwortlich für direkte oder indirekte Schäden, spezielle oder Folgeschäden, die Ihnen oder einer anderen Person durch die Nutzung der WebApp entstehen, auch wenn Sie auf die Möglichkeit solcher Schäden hingewiesen wurden. Kein Rat oder keine Informationen, ob mündlich oder schriftlich, die Sie von uns oder unserer WebApp erhalten, schaffen eine Garantie, die nicht ausdrücklich in den AGB angegeben ist. Unter keinen Umständen überschreitet unsere Haftung oder die unserer Tochtergesellschaften, je nach Klagegrund, sei es aus Vertrag, Delikt oder anderweitig, die von Ihnen gezahlte Gebühr für den Zugriff auf die WebApp. Darüber hinaus übernehmen wir keine Verantwortung oder Haftung für Verzögerungen oder Ausfälle aufgrund von Umständen, die außerhalb unserer Kontrolle liegen.",
      },
    },
    transfer_of_rights: {
      title: "10. ÜBERTRAGUNG VON RECHTEN",
      list: {
        transfer_by_company:
          "Wir können unsere Rechte und Pflichten aus dieser EULA ohne Ihre Zustimmung auf jede andere Organisation oder Person übertragen. Wir werden Sie schriftlich informieren, wenn dies geschieht, und sicherstellen, dass der Transfer Ihre Rechte aus der EULA nicht beeinträchtigt.",
        transfer_by_user:
          "Sie dürfen Ihre Rechte oder Pflichten aus dieser EULA nur an eine andere Person übertragen, wenn wir schriftlich zustimmen.",
      },
    },
    termination_of_rights: {
      title: "11. KÜNDIGUNG DER RECHTE",
      list: {
        termination_for_breach:
          "Wir können Ihre Rechte zur Nutzung der WebApp jederzeit beenden, indem wir Sie kontaktieren, wenn Sie die Regeln dieser EULA schwerwiegend verletzt haben. Wenn das, was Sie getan haben, behoben werden kann, werden wir Ihnen eine angemessene Gelegenheit geben, dies zu tun.",
        actions_upon_termination: {
          title: "Wenn wir Ihre Rechte zur Nutzung der WebApp beenden:",
          a: "Sie müssen alle durch diese EULA autorisierten Aktivitäten einstellen, einschließlich Ihrer Nutzung der WebApp.",
          b: "Sie müssen die WebApp von allen Geräten löschen oder entfernen und alle Kopien der WebApp, die Sie haben, sofort zerstören und uns bestätigen, dass Sie dies getan haben.",
        },
      },
    },
    miscellaneous: {
      title: "12. SONSTIGES",
      list: {
        separation_of_paragraphs:
          "Jeder der Absätze dieser EULA wirkt separat. Wenn ein Gericht oder eine zuständige Behörde entscheidet, dass einer von ihnen rechtswidrig ist, bleiben die verbleibenden Absätze in vollem Umfang und mit voller Wirkung in Kraft.",
        delay_in_enforcement:
          "Selbst wenn wir die Durchsetzung dieser EULA verzögern, können wir sie später dennoch durchsetzen. Wenn wir nicht sofort darauf bestehen, dass Sie etwas tun, was Sie gemäß den Bedingungen dieser EULA tun müssen, oder wenn wir Maßnahmen gegen Sie wegen einer Verletzung der EULA verzögern, bedeutet dies nicht, dass Sie diese Dinge nicht tun müssen, und es wird uns nicht daran hindern, später Maßnahmen gegen Sie zu ergreifen.",
        governing_law:
          "Diese EULA unterliegt den Gesetzen von Dublin, Irland, ohne Rücksicht auf seine Kollisionsnormen.",
        dispute_resolution:
          "Sollte ein Streit, eine Kontroverse oder eine Differenz zwischen Ihnen und dem Unternehmen entstehen, wird dieser durch Verhandlungen einvernehmlich geklärt. Falls ein solcher Streit, eine Kontroverse oder eine Differenz innerhalb von dreißig (30) Tagen nicht einvernehmlich geklärt werden kann, wird dieser von der Irish Arbitration Association gemäß ihren Internationalen Beschleunigten Verfahren entschieden.",
        number_of_arbitrators: "Die Anzahl der Schiedsrichter beträgt eins.",
        place_of_arbitrators:
          "Der Ort des Schiedsverfahrens ist Dublin, Irland.",
        language_of_arbitrators:
          "Das Schiedsverfahren wird in Englisch durchgeführt und die Entscheidung wird in Englisch getroffen.",
        expense:
          "Jede Partei (d.h. Sie und das Unternehmen) trägt ihre eigenen Kosten, jedoch teilen sich die Parteien die Kosten des Schiedsgerichts gleichermaßen.",
        support:
          "Support. Wenn Sie mehr über die WebApp erfahren möchten oder Probleme bei deren Nutzung haben, kontaktieren Sie uns bitte unter <tag>support@freelanz.app</tag>",
      },
    },
  },
  privacy_policy: {
    title: "Politica sulla Privacy",
    commitment_title: "Il Nostro Impegno per la Tua Privacy",
    commitment_text:
      "Rispettiamo e proteggiamo la privacy dei nostri utenti della WebApp. Questa Politica sulla Privacy spiega come raccogliamo e utilizziamo le tue informazioni ed è parte dei nostri Termini di Utilizzo quando utilizzi la nostra WebApp. Utilizzando la nostra WebApp e il servizio fornito tramite la WebApp (« Servizio »), accetti la nostra Politica sulla Privacy. Se non sei d'accordo, ti preghiamo di non utilizzare la nostra WebApp.",
    info_collection_title: "Quali informazioni raccogliamo?",
    info_collection_text:
      "Se effettui acquisti o acquisti un abbonamento, i nostri fornitori di servizi di fatturazione di terze parti raccoglieranno informazioni come il tuo nome completo, il numero della tua carta di credito e l'indirizzo di fatturazione. Se ci invii un'e-mail, potremmo utilizzare il tuo indirizzo e-mail per rispondere al tuo messaggio. Informazioni inviate dal tuo dispositivo mobile. Raccogliamo alcune informazioni che il tuo dispositivo mobile invia quando utilizzi la nostra WebApp, come un identificatore del dispositivo, le impostazioni dell'utente e il sistema operativo del tuo dispositivo, oltre a informazioni sull'uso dei nostri Servizi. Informazioni sulla posizione. Quando utilizzi la nostra WebApp, possiamo raccogliere e memorizzare informazioni sulla tua posizione convertendo il tuo indirizzo IP in una geo-localizzazione approssimativa o accedendo alle coordinate GPS del tuo dispositivo mobile o a una posizione approssimativa se abiliti i servizi di localizzazione sul tuo dispositivo. Possiamo utilizzare le informazioni sulla posizione per migliorare e personalizzare i nostri Servizi per te. Se non desideri che raccogliamo informazioni sulla posizione, puoi disabilitare questa funzione sul tuo dispositivo mobile.",
    info_storage_title: "Dove memorizziamo le tue informazioni?",
    info_storage_text:
      "Le tue informazioni possono essere memorizzate sui nostri server o su server di fornitori di archiviazione cloud di terze parti. I fornitori di archiviazione di terze parti possono utilizzare le tue informazioni solo come previsto in questa Politica sulla Privacy.",
    info_usage_title: "Come utilizziamo le tue informazioni?",
    info_usage_text:
      "Le informazioni che raccogliamo da te potrebbero essere utilizzate:",
    info_storage_duration_title:
      "Per quanto tempo memorizziamo le tue informazioni?",
    info_storage_duration_text:
      "Intendiamo memorizzare alcune delle tue informazioni indefinitamente. E i link ad altri siti web? Potremmo fornire collegamenti a o compatibilità con altri siti web. Tuttavia, non siamo responsabili delle pratiche di privacy adottate da tali siti web o delle informazioni o contenuti che contengono.",
    info_protection_title: "Come proteggiamo le tue informazioni?",
    info_protection_text:
      "Utilizziamo procedure fisiche, elettroniche e altre adeguate per proteggere e garantire le informazioni che raccogliamo. Tuttavia, sii consapevole che Internet è un ambiente intrinsecamente non sicuro e che gli hacker lavorano costantemente per superare le misure di sicurezza. Pertanto, non possiamo garantire che le tue informazioni non vengano accessibili, divulgate, modificate o distrutte, e accetti questo rischio.",
    user_protection_title: "Come puoi proteggere le tue informazioni?",
    user_protection_text:
      "Ti incoraggiamo a prendere misure per mantenere sicure le tue informazioni personali non condividendole con altri o pubblicandole online.",
    disclosure_title: "Divulghiamo informazioni a terzi?",
    disclosure_text:
      "Non raccogliamo, vendiamo, scambiamo o trasferiamo in altro modo le tue Informazioni Personali Identificabili (PII) a terzi per scopi commerciali o di marketing, tranne come indicato nella presente Politica sulla Privacy. Le informazioni personali (e non personali) raccolte tramite il Sito possono essere condivise con aziende e organizzazioni che svolgono servizi per nostro conto (ad esempio, aziende che forniscono servizi di gestione dei dati o altri servizi di supporto come l'archiviazione dei dati e i servizi di hosting web). Possiamo condividere le tue informazioni personali (e non personali) con terzi per offrirti pubblicità rilevanti e promuovere i nostri prodotti, ma non venderemo le tue informazioni personali. Informazioni divulgate in relazione a transazioni aziendali. Se siamo acquisiti da un terzo a seguito di una transazione come una fusione, acquisizione o vendita di beni o se i nostri beni sono acquisiti da un terzo in caso di fallimento o cessazione dell'attività, alcuni o tutti i nostri beni, comprese le tue PII, potrebbero essere divulgati o trasferiti a un acquirente terzo in relazione alla transazione. Informazioni divulgate per la nostra protezione e quella degli altri. Collaboriamo con le autorità governative e le forze dell'ordine o le parti private per far rispettare e conformarsi alla legge. Possiamo divulgare qualsiasi informazione su di te alle autorità governative o alle forze dell'ordine o alle parti private come riteniamo, a nostra esclusiva discrezione, necessario o appropriato: (i) per rispondere a reclami, procedimenti legali (comprese le citazioni); (ii) per proteggere i nostri beni, diritti e sicurezza e i beni, diritti e sicurezza di un terzo o del pubblico in generale; e (iii) per fermare qualsiasi attività che consideriamo illegale, non etica o legalmente perseguibile.",
    not_for_children_title: "Non destinato ai minori",
    not_for_children_text:
      "La nostra WebApp e il Servizio non sono destinati ai minori di 16 anni. Non raccogliamo consapevolmente né specificamente informazioni da o su minori di 16 anni.",
    policy_changes_title: "Modifiche alla nostra Politica sulla Privacy",
    policy_changes_text:
      "Se decidiamo di modificare la nostra Politica sulla Privacy, pubblicheremo tali modifiche su questa pagina. Possiamo anche, ma non siamo obbligati a, inviarti una notifica via e-mail. Ti incoraggiamo a consultare frequentemente questa politica sulla privacy per essere informato su come proteggiamo le tue informazioni.",
    contact_title: "Contattaci",
    contact_text:
      "Se hai domande sulla nostra Politica sulla Privacy, ti preghiamo di contattarci all'indirizzo <tag>support@freelanz.app</tag>",
  },
};

export const screens_de_Translation = {
  common_text: {
    male: "Männlich",
    female: "Weiblich",
    terms_and_conditions: "Allgemeine Geschäftsbedingungen",
    privacy_policy: "Datenschutzrichtlinie",
    copy_right: "Urheberrecht ® 2024. Alle Rechte vorbehalten.",
    continue: "Weiter",
    login_text: "ANMELDEN",
  },
  landing_page: {
    title: "Personalisierte KI-Kurse",
    personalized_freelance_plan: "Schaffen Sie Ihren Weg zur Freiheit",
    start_freelance_business:
      "Starten Sie ein Freiberufler-Geschäft: <tag/>Seien Sie Ihr eigener Chef",
    launch_successful_business:
      "Starten Sie noch heute Ihr erfolgreiches Freiberufler-Geschäft",
    select_text: "Wählen Sie Ihr Geschlecht:",
  },
  career_plan: {
    title: "Karrierefreiheitsplan nach Ihrem Alter",
    age_18_24: "18-24",
    age_25_34: "25-34",
    age_35_44: "35-44",
    age_45_plus: "45+",
  },
  community: {
    title: "$36.000",
    sub_title: "könnte der Beginn Ihres Freiberufler-Abenteuers sein",
  },
  goal_selection: {
    question: "Was ist Ihr Ziel?",
    priority: "Bitte wählen Sie Ihre erste Priorität aus",
    grow_wealth: "Vermögen aufbauen",
    be_boss: "Mein eigener Chef sein",
    travel_more: "Mehr reisen",
    other: "Andere",
  },
  income_source: {
    question: "Was ist Ihre derzeitige Einkommensquelle?",
    job: "9 bis 5 Job",
    freelance: "Freelance",
    other: "Andere",
  },
  income_level: {
    question: "Wählen Sie Ihr aktuelles Einkommensniveau",
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
  },
  financial_situation: {
    question: "Wie würden Sie Ihre finanzielle Situation beschreiben?",
    struggling: "Ich kämpfe, meine finanziellen Ziele zu erreichen",
    stability: "Ich hätte gerne mehr Stabilität",
    unsure: "Ich bin mir nicht sicher",
    comfortable: "Ich bin komfortabel",
    range_30_50k: "$30.000-$50.000",
    range_50_100k: "$50.000-$100.000",
    range_above_100k: "Mehr als $100.000",
  },
  remote_work: {
    question:
      "Wertschätzen Sie die Flexibilität von Remote-Arbeit in Ihrer Karriere?",
    yes: "Ja",
    maybe: "Vielleicht",
    no: "Nein",
  },
  work_family_balance: {
    question:
      "Haben Sie Schwierigkeiten, Arbeit und Familienzeit in Einklang zu bringen?",
    absolutely: "Absolut",
    somewhat: "Etwas",
    work_life_balance: "Ich habe eine Work-Life-Balance",
    prefer_not_to_say: "Möchte ich nicht sagen",
  },
  work_situation: {
    question: "Welche Art von Arbeitssituation streben Sie an?",
    remote_balance: "Remote-Balance",
    stable_routine: "Stabile Routine",
    exploring_options: "Ich erkunde Optionen",
  },
  travel_while_working: {
    question: "Wünschen Sie, dass Sie reisen könnten, während Sie arbeiten?",
    dream: "Es ist ein Traum",
    traveling: "Ich reise",
    sometimes: "Manchmal",
    not_priority: "Keine Priorität",
  },
  content_writing_knowledge: {
    question: "Bewerten Sie Ihr Wissen im Bereich Content Writing",
    upwork_info:
      "Laut Upwork verdient ein freiberuflicher Content Writer etwa 42.000 US-Dollar pro Jahr",
    need_more_info: "Ich brauche mehr Informationen",
    know_everything: "Ich weiß alles",
  },
  ai_content_creation: {
    question:
      "Wussten Sie, dass KI-Tools die Erstellung von Inhalten noch einfacher machen können?",
    no_news: "Nein, das ist neu für mich",
    curious: "Ich bin neugierig",
    heard_of_it: "Ja, davon habe ich gehört",
  },
  digital_marketing_knowledge: {
    question: "Bewerten Sie Ihr Wissen im Bereich digitales Marketing",
    upwork_info:
      "Laut Upwork verdient ein Digital Marketer etwa 100.000 US-Dollar pro Jahr.",
    need_more_info: "Ich brauche mehr Informationen",
    know_everything: "Ich weiß alles",
  },
  promote_business_ability: {
    question: "Bewerten Sie Ihre Fähigkeit, ein Geschäft zu fördern",
    upwork_info:
      "70% der Freiberufler finden ihren Job online, und das können Sie auch.",
    need_more_info: "Ich brauche mehr Informationen",
    know_everything: "Ich weiß alles",
  },
  ai_promotion_help: {
    question:
      "Wussten Sie, dass KI-Tools Ihnen bei der Promotion helfen können?",
    no_news: "Nein, das ist neu für mich",
    curious: "Ich bin neugierig",
    heard_of_it: "Ja, davon habe ich gehört",
  },
  job_interests: {
    question: "Wählen Sie Jobs aus, die Sie interessieren könnten",
    digital_marketing: "Digitales Marketing",
    smm: "SMM",
    affiliate_marketing: "Affiliate-Marketing",
    dropshipping: "Dropshipping",
    content_writing: "Content Writing",
    copywriting: "Copywriting",
    translation: "Übersetzung",
    graphic_design: "Grafikdesign",
    blogging: "Bloggen",
    illustration: "Illustration",
    continue: "Fortfahren",
  },
  freelancing_readiness: {
    question: "Bewerten Sie Ihre Bereitschaft, mit dem Freelancing zu beginnen",
    need_more_info: "Ich brauche mehr Informationen",
    know_everything: "Ich weiß alles",
  },
  freelance_platforms: {
    question: "Freelance-Plattformen, von denen Sie gehört haben",
    freelancer: "Freelancer",
    linkedin: "LinkedIn",
    fiverr: "Fiverr",
    guru: "Guru",
    toptal: "Toptal",
    upwork: "Upwork",
    designhill: "Designhill",
    flexjobs: "Flexjobs",
    behance: "Behance",
    wwr: "WWR",
  },
  summary_screen: {
    title: "Zusammenfassung Ihres <tag>Freelancing-Profils</tag>",
    readiness_score: "Bereitschaft <tag/> Bewertung",
    result_perfect: "Ergebnis: Perfekt",
    required_score: "Erforderlich - 75",
    impressive_score:
      "Beeindruckende Punktzahl, um im Freelancing erfolgreich zu sein",
    description:
      "Freelancer genießen größere Flexibilität und Verdienstmöglichkeiten, wobei 61% von ihnen mehr verdienen als in traditionellen Jobs. Auch Sie können von Freelancing profitieren.",
    mindset: "DENKEN",
    entrepreneur: "Unternehmer",
    motivation: "MOTIVATION",
    high: "Hoch",
    time_for_freelancing: "ZEIT",
    for_freelancing: "Für Freelancing",
    knowledge: "WISSEN",
    beginner: "Anfänger",
  },
  special_achievement: {
    question:
      "Gibt es etwas <tag/> Besonderes, das Sie <tag/> erreichen möchten?",
    options: {
      buy_house: "Ein Haus kaufen",
      perfect_wedding: "Eine perfekte Hochzeit",
      vacation: "Urlaub",
      buy_car: "Ein neues Auto kaufen",
      retirement: "Sorgenfreier Ruhestand",
    },
    continue: "Fortfahren",
  },
  time_to_goal: {
    question:
      "Wie viel Zeit sind Sie bereit, für das Erreichen Ihres Ziels aufzuwenden?",
    options: {
      five_min: "5 Min/Tag",
      ten_min: "10 Min/Tag",
      fifteen_min: "15 Min/Tag",
      twenty_min: "20 Min/Tag",
    },
  },
  personal_plan: {
    title: "Ihr persönlicher Plan zur beruflichen Freiheit",
    based_on_answers:
      "Basierend auf Ihren Antworten erwarten wir, dass Sie die notwendigen Freelance-Fähigkeiten bis",
    confident_freelancer_by:
      "Selbstbewusster Freelancer bis {{month}}, {{year}}",
    confident: "Selbstbewusst",
    freelancer: "Freelancer",
    beginner: "Anfänger",
  },
  designing_plan: {
    title: "Wir erstellen Ihren Plan zur beruflichen Freiheit…",
    people_chosen: "70.000+ Menschen",
    chosen_freelanz_app: "haben Freelanz.app gewählt",
    exploring_financial_freedom: "Finanzielle Freiheit erkunden",
    essential_guide: "Wichtiger Leitfaden",
    great_discovery: "Große Entdeckung",
  },
  testimonials: {
    sean: {
      name: "Sean",
      text: "FreeLanz ermöglicht finanzielle Freiheit durch Freelance-Arbeit. Die optimierte Benutzeroberfläche und die vielfältigen Möglichkeiten machen es zu einer wertvollen Ressource für neue Freelancer wie mich.",
    },
    angel: {
      name: "Angel",
      text: "Ich bin begeistert von meiner Lernreise mit FreeLanz, wo eine Vielzahl von Freelance-Themen in ihren Kursen behandelt werden. Das Copywriting sticht als mein Favorit hervor.",
    },
    trisha: {
      name: "Trisha",
      text: "FreeLanz hat mich inspiriert, Wissen in Technologie und KI zu erwerben und hat mich dazu gebracht, meine Ängste zu überwinden und hohe Ziele anzustreben!",
    },
  },
  email_signup: {
    title:
      "Geben Sie Ihre E-Mail-Adresse ein, um Ihren persönlichen <tag>Karriere-Freiheits</tag> Plan zu erhalten!",
    privacy_note:
      "Wir respektieren Ihre Privatsphäre. Ihre E-Mail-Adresse kann das Werbeerlebnis relevanter machen <tag> Datenschutzrichtlinie </tag>.",
    email_label: "Ihre E-Mail",
    email_placeholder: "Geben Sie eine gültige E-Mail-Adresse ein",
    success_message: "Gut gemacht!",
  },
  login: {
    title: "Anmelden",
    description:
      "Geben Sie Ihre registrierte E-Mail-Adresse ein, um die App zu betreten",
    email_label: "Ihre E-Mail",
    email_placeholder: "Geben Sie eine gültige E-Mail-Adresse ein",
    login_button: "Anmelden",
    no_account: "Noch kein Konto? <tag>Registrieren</tag>",
  },
  career_plan_ready: {
    title: "Ihr 4-Wochen-Karriere-Freiheits-Plan ist fertig!",
    readiness_level: "Ihr Bereitschaftsniveau",
    after_4_weeks: "Nach 4 Wochen",
    now: "Jetzt",
    week_labels: {
      week_1: "Woche 1",
      week_2: "Woche 2",
      week_3: "Woche 3",
      week_4: "Woche 4",
    },
  },
  otp: {
    title: "Geben Sie OTP ein",
    message:
      "Ein einmaliges Passwort wurde an Ihre <tag/> E-Mail: {{email}} gesendet",
    submit_button: "Absenden",
    resend_otp: "OTP erneut senden",
  },
  payment: {
    email: "E-Mail",
    email_placeholder: "Geben Sie eine gültige E-Mail-Adresse ein",
    card_number: "KARTENNUMMER",
    expires_on: "AUSLAUFDATUM",
    process_card: "Karte verarbeiten",
    discount_expires: "Rabatt läuft ab in",
    try_now: "JETZT AUSPROBIEREN",
    min: "Min",
    sec: "Sek",
    now: "Jetzt",
    goal: "Ziel",
    flexibility: "Flexibilität",
    earning_power: "Ertragskraft",
    limited: "Begrenzt",
    high: "Hoch",
    basic: "Grundlegend",
    disclaimer: "Dies ist keine Garantie oder Versprechen für Ergebnisse.",
    trial_offer:
      "Testen Sie <tag>FreeLanz 7 Tage für $1</tag>, und Sie werden:",
    // trial_offer:
    //   "Probieren Sie <tag>Freelanz 4 Wochen</tag> aus und Sie werden:",
    benefits: {
      ai_tools: "Erlernen Sie AI-Tools, die Ihr Einkommen steigern können",
      additional_sources: "Entdecken Sie zusätzliche Einkommensquellen",
      skills:
        "Erwerben Sie die Fähigkeiten eines Freelance-Profis und starten Sie Ihre Einnahmen",
      beginner_lessons: "Zugang zu anfängerfreundlichen Lektionen",
      guidance: "Anleitung für Kompetenz und Erfolg im Freelancing",
    },
    trial: "7-Tage-Testversion",
    // trial: "4-WOCHENPLAN",
    payment_methods: "Kredit <tag>/</tag> Debitkarte",
    guaranteed_checkout: "Garantierter <tag>Sicherer</tag> Checkout",
    what_you_get: "Was Sie erhalten",
    income_know_how: "Know-how zum Freelance-Einkommen",
    lessons: "Aufschlussreiche, einfache und unterhaltsame Lektionen",
    personal_coach:
      "24/7 Chat mit Ihrem persönlichen Coach, um alle Antworten zu erhalten und Fehler zu minimieren",
    users_love: "Nutzer lieben unsere Pläne",
    user_reviews: {
      review_1:
        "Ich schätze die Lektionen, die ihr zu verschiedenen Themen bietet. Ich bin entschlossen, in diesem Bereich erfolgreich zu sein, und habe wertvolle Einblicke gewonnen. Es war eine lohnende Erfahrung, und ich habe viel Wissen aufgenommen.",
      review_2:
        "Ich muss anerkennen, dass dieser Kurs zu den besten gehört, die ich je gemacht habe. Er vermittelt praktische Einblicke in den Bereich des digitalen Marketings.",
      review_3:
        "Diese Kurse waren außergewöhnlich nützlich. Ich habe noch nie eine Anwendung erlebt, die so umfassende Informationen wie Coursiv bietet. Das Bemerkenswerte ist, dass ich ständig neue Strategien und Taktiken lerne, um mich online zu vermarkten.",
    },
    career_titles: {
      digital_marketing: "Digital Marketing",
      content_writer: "Content Writer",
      graphic_designer: "Grafikdesigner",
    },
    career_info: {
      digital_marketing: "$100.000 pro Jahr",
      content_writer: "$42.000 pro Jahr",
      graphic_designer: "$90.000 pro Jahr",
    },
    no_degree: "Keine Notwendigkeit für einen Berufsausweis",
    no_university_degree: "Kein Hochschulabschluss erforderlich",
    work_at_your_pace:
      "Arbeiten Sie in Ihrem eigenen Tempo und nach Ihren Bedingungen",
    people_often_ask: "Häufige Fragen",
    faqs: {
      career_freedom_plan:
        "Worum geht es beim Karriere-Freiheits-Plan, und wie kann ich starten?",
      commitment_concerns:
        "Ich mache mir Sorgen, mich auf Freelancing einzulassen und dann mitten im Weg aufzugeben.",
      technical_skills:
        "Ist es möglich, Freelancing ohne spezialisierte technische Fähigkeiten zu lernen?",
    },
    faq_answers: {
      career_freedom_plan:
        "FreeLanz bietet jedem die Möglichkeit, sich mit Freelancing auseinanderzusetzen, indem es zugängliche Lernmaterialien bereitstellt. Der Karriere-Freiheits-Plan konzentriert sich darauf, wesentliche Freelance-Fähigkeiten in einem benutzerfreundlichen, spielerischen Format zu vermitteln, das potenziell komplexe Konzepte auf leicht verständliche Weise behandelt.",
      commitment_concerns:
        "Wir verstehen Ihre Bedenken, deshalb sorgt FreeLanz für ein anfängerfreundliches Erlebnis. Unser KI-Mentor steht Ihnen während Ihrer gesamten Reise zur Verfügung und benötigt nur wenig Aufwand von Ihrer Seite.",
      technical_skills:
        "Absolut! Unsere Lernressourcen sind darauf ausgelegt, technische Themen zu vereinfachen und zugänglich zu machen. Während eine gewisse technische Vorkenntnis von Vorteil sein kann, ist sie für den Erfolg im Freelancing nicht unbedingt erforderlich.",
    },
    money_back_guarantee: "100% Geld-zurück-Garantie",
    guarantee_message:
      "Wir glauben, dass unser Plan für Sie funktionieren kann und Sie in 4 Wochen Ergebnisse sehen werden! Wir sind sogar bereit, Ihr Geld zurückzugeben, wenn Sie keine Ergebnisse sehen, aber das hängt hauptsächlich von Ihnen ab. Bitte überprüfen Sie unsere <tag>Rückerstattungsrichtlinie</tag>, um alle Anforderungen zu verstehen.",
  },
};
